/* @sravni/react-header version 0.2.43 */
import React__default from 'react';
import modules_3b87a8fb from '../styles/InjectedIcon.module.less.js';

var InjectedIcon = function (_a) {
    var iconSrc = _a.iconSrc;
    return (React__default.createElement("span", { className: modules_3b87a8fb.container, dangerouslySetInnerHTML: { __html: iconSrc } }));
};

export { InjectedIcon as default };
//# sourceMappingURL=InjectedIcon.js.map
